import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import { FC, useEffect, useState } from "react";
import FlexBox from "../../FlexBox";
import { Button, Typography } from "@mui/material";
import DrawerBox from "../DrawerBox";
import GeoLocatorMap from "./GeoLocatorMap";
import { useDrawerContext } from "../../../contexts/DrawerContext";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";

export const hasCoordinates = (data: any) => {
  return !!data?.latitude && !!data?.longitude;
};

export interface IGeoLocatorCoordinatesParams {
  latitude: number;
  longitude: number;
  title?: string;
  zoom?: number;
}

interface IGeoLocatorProps {
  location: IGeoLocatorCoordinatesParams;
  editable?: boolean;
  setLocation?: (location: any) => void;
  isDisabled?: boolean;
  modalId: any;
  locations?: IGeoLocatorCoordinatesParams[];
  drawerZIndex?: number;
}

const GeoLocator: FC<IGeoLocatorProps> = ({
  location,
  setLocation,
  editable,
  isDisabled,
  modalId,
  locations,
  drawerZIndex,
}) => {
  const { showDrawer, setShowDrawer, setDrawerId } = useDrawerContext();

  const handleOpenDrawer = () => {
    setDrawerId(modalId);
    setShowDrawer({ ...showDrawer, ...{ right: true } });
  };

  const closeDrawer = () => {
    setShowDrawer({ ...showDrawer, ...{ right: false } });
  };

  return (
    <>
      <FlexBox gap={2} alignItems={"center"}>
        <Button
          onClick={handleOpenDrawer}
          sx={[styles.locationButton]}
          disabled={isDisabled}
        >
          <GpsFixedIcon />
        </Button>
        {hasCoordinates(location) && (
          <FlexBox
            flexDirection={"column"}
            sx={{
              background:
                "radial-gradient(circle, rgb(240 218 190 / 27%) 0%, rgb(228 228 228) 100%)",
              padding: 0.5,
              px: 2,
              borderRadius: 2,
              width: "100%",
            }}
          >
            <Typography fontSize={11} fontWeight={600}>
              Longitude : {location?.longitude}{" "}
            </Typography>
            <Typography fontSize={11} fontWeight={600}>
              Latitude : {location?.latitude}{" "}
            </Typography>
          </FlexBox>
        )}
      </FlexBox>

      {showDrawer && modalId && (
        <DrawerBox
          zIndex={drawerZIndex}
          minWidth={1000}
          maxWidth={1000}
          selectedDrawerId={modalId}
          anchor="right"
          onClose={() => {}}
        >
          <GeoLocatorMap
            editable={editable}
            closeDrawer={closeDrawer}
            setLocation={setLocation && setLocation}
            initialLocation={location}
            locations={locations}
          />
        </DrawerBox>
      )}
    </>
  );
};

const styles = {
  locationButton: {
    borderRadius: "50%",
    border: "2px solid #5e95ff",
    height: 35,
    width: 35,
    minWidth: 35,
    padding: 2,
    "& .MuiSvgIcon-root": {
      color: "#5e95ff",
      fontSize: 20,
    },
    "&:hover": {
      "& .MuiSvgIcon-root": {
        color: "#5e95ff",
      },
    },
  },
};

export default GeoLocator;
